<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'leaderboard.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      @if (!enabled()) {
        <p class="empty-state" data-testid="leaderboard-disabled">
          {{ 'leaderboard.disabled' | translate }}
          @if (canManageSettings) {
            <a routerLink="/settings">{{ 'leaderboard.disabledSettingsLink' | translate }}</a>
          }
        </p>
      } @else {
        <app-report-filter-bar [includeAllUsers]="includeAllUsers" (filtersChange)="onFiltersChange($event)" />

        <form [formGroup]="metricGroupForm" class="metric-group-form">
          <formly-form [form]="metricGroupForm" [fields]="metricGroupFields" [model]="metricGroupModel" />
        </form>

        @if (loading()) {
          <div class="loading-container flex flex-column flex-align-center p-lg">
            <app-spinner />
          </div>
        } @else if (entries().length === 0) {
          <p class="empty-state" data-testid="leaderboard-empty">{{ 'leaderboard.empty' | translate }}</p>
        } @else {
          <ol class="leaderboard-list" data-testid="leaderboard-list">
            @for (entry of entries(); track entry.groupKey) {
              <li class="leaderboard-row" [attr.data-testid]="'leaderboard-row-' + entry.groupKey">
                <span class="leaderboard-rank">#{{ entry.rank }}</span>
                <span class="leaderboard-label">{{ entry.groupLabel }}</span>
                <span class="leaderboard-metric">{{ metricGroupModel.metric === 'doors' ? entry.doors : entry.leads }}</span>
              </li>
            }
          </ol>
        }
      }
    </app-card-content>
  </app-card>
</div>
